







import Vue from "vue";
import { store } from "../services/store";

export default Vue.extend({
  computed: {
    globalLoading() {
      return store.globalLoading;
    },
    picShareLoading() {
      return store.loading;
    }
  }
});
